// Re-exporta tipos compartilhados do shared.ts para manter compatibilidade
export {
    EmailType,
    EMAIL_TYPE_LABELS,
    getEmailTypeLabel,
    ItemType as EmailItemType,
    ReviewStatus as ItemStatus,
    getStatusLabel as getItemStatusLabel,
    getStatusVariant as getItemStatusVariant,
} from "@/pages/conciliation/stores/conciliation/email-review/types/shared";

import {
    EmailType,
    EMAIL_TYPE_LABELS,
    ReviewStatus,
} from "@/pages/conciliation/stores/conciliation/email-review/types/shared";

export enum ConciliationEmailReportType {
    EMAILS_BY_STORE = 'EMAILS_BY_STORE',
    EMAILS_BY_REGIONAL = 'EMAILS_BY_REGIONAL',
    DETAILED_DIVERGENCE = 'DETAILED_DIVERGENCE',
    DETAILED_NSU = 'DETAILED_NSU',
    SENT_EMAILS = 'SENT_EMAILS',
    EMAILS_BY_CONCILIATION = 'EMAILS_BY_CONCILIATION',
}

export const LIST_TYPES = [
    {
        label: 'Quantidade de Email por Loja',
        value: ConciliationEmailReportType.EMAILS_BY_STORE,
    },
    {
        label: 'Quantidade de Email por Regional',
        value: ConciliationEmailReportType.EMAILS_BY_REGIONAL,
    },
    {
        label: 'Divergência Detalhada',
        value: ConciliationEmailReportType.DETAILED_DIVERGENCE,
    },
    {
        label: 'NSU Detalhada',
        value: ConciliationEmailReportType.DETAILED_NSU,
    },
    {
        label: 'Todos E-mails Enviados',
        value: ConciliationEmailReportType.SENT_EMAILS,
    },
];

export interface SelectOption {
    value: string | number;
    label: string;
}

export interface EmailReportFilters {
    storeCode?: string;
    regional?: string;
    operator?: string;
    sent_at?: string;
    storeAllowedToReceiveEmails?: boolean;
    is_finalized?: boolean;
    type?: string;
}

export const EMAIL_TYPE_OPTIONS: SelectOption[] = [
    { value: EmailType.CONFERENCIA_CAIXA, label: EMAIL_TYPE_LABELS[EmailType.CONFERENCIA_CAIXA] },
    { value: EmailType.COMPROVANTE_DEPOSITOS, label: EMAIL_TYPE_LABELS[EmailType.COMPROVANTE_DEPOSITOS] },
    { value: EmailType.LANCAMENTO_DEPOSITOS, label: EMAIL_TYPE_LABELS[EmailType.LANCAMENTO_DEPOSITOS] },
];

export const ITEM_STATUS_LABELS: Record<string, string> = {
    [ReviewStatus.PENDING_ANSWER]: 'Aguardando Resposta',
    [ReviewStatus.RESPONDED]: 'Respondido',
    [ReviewStatus.REJECTED_WAITING_FOR_RESPOND]: 'Aguardando Nova Resposta',
    [ReviewStatus.APPROVED]: 'Aprovado',
    [ReviewStatus.REJECTED]: 'Reprovado',
};

export const ITEM_STATUS_OPTIONS: SelectOption[] = [
    { value: ReviewStatus.PENDING_ANSWER, label: ITEM_STATUS_LABELS[ReviewStatus.PENDING_ANSWER] },
    { value: ReviewStatus.RESPONDED, label: ITEM_STATUS_LABELS[ReviewStatus.RESPONDED] },
    { value: ReviewStatus.REJECTED_WAITING_FOR_RESPOND, label: ITEM_STATUS_LABELS[ReviewStatus.REJECTED_WAITING_FOR_RESPOND] },
    { value: ReviewStatus.APPROVED, label: ITEM_STATUS_LABELS[ReviewStatus.APPROVED] },
];

// Status agregados para e-mails (usados na tab SENT_EMAILS)
export enum AggregatedStatusEnum {
    PENDING = 'PENDING',
    IN_ANALYSIS = 'IN_ANALYSIS',
    AWAITING_STORE = 'AWAITING_STORE',
    RESPONDED = 'RESPONDED',
    FINALIZED = 'FINALIZED',
}

export const AGGREGATED_STATUS_LABELS: Record<string, string> = {
    [AggregatedStatusEnum.PENDING]: 'Pendente',
    [AggregatedStatusEnum.IN_ANALYSIS]: 'Em Análise',
    [AggregatedStatusEnum.AWAITING_STORE]: 'Aguardando Loja',
    [AggregatedStatusEnum.RESPONDED]: 'Respondido',
    [AggregatedStatusEnum.FINALIZED]: 'Finalizado',
};

export const AGGREGATED_STATUS_OPTIONS: SelectOption[] = [
    { value: AggregatedStatusEnum.PENDING, label: AGGREGATED_STATUS_LABELS[AggregatedStatusEnum.PENDING] },
    { value: AggregatedStatusEnum.IN_ANALYSIS, label: AGGREGATED_STATUS_LABELS[AggregatedStatusEnum.IN_ANALYSIS] },
    { value: AggregatedStatusEnum.AWAITING_STORE, label: AGGREGATED_STATUS_LABELS[AggregatedStatusEnum.AWAITING_STORE] },
    { value: AggregatedStatusEnum.RESPONDED, label: AGGREGATED_STATUS_LABELS[AggregatedStatusEnum.RESPONDED] },
    { value: AggregatedStatusEnum.FINALIZED, label: AGGREGATED_STATUS_LABELS[AggregatedStatusEnum.FINALIZED] },
];
